import { render, staticRenderFns } from "./BalanceView.vue?vue&type=template&id=35c3baf2&scoped=true&"
import script from "./BalanceView.vue?vue&type=script&lang=js&"
export * from "./BalanceView.vue?vue&type=script&lang=js&"
import style0 from "./BalanceView.vue?vue&type=style&index=0&id=35c3baf2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c3baf2",
  null
  
)

export default component.exports